import { z } from "zod";

// Unset and blank values are valid for local runs. A present value must be a real string.
const optionalEnvString = z.preprocess((value) => {
  if (value === undefined || value === null) return undefined;
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}, z.string().min(1).optional());

/** Browser values. Vite inlines VITE_* at build time. A missing DSN leaves Sentry off. */
export const browserSentryEnvSchema = z.object({
  VITE_SENTRY_DSN: optionalEnvString,
  VITE_VERCEL_GIT_COMMIT_SHA: optionalEnvString,
});

/** Release id injected by Vite. Either source may be absent outside Vercel. */
export const viteReleaseEnvSchema = z.object({
  VERCEL_GIT_COMMIT_SHA: optionalEnvString,
  VITE_VERCEL_GIT_COMMIT_SHA: optionalEnvString,
});

export type BrowserSentryEnv = z.infer<typeof browserSentryEnvSchema>;
export type ViteReleaseEnv = z.infer<typeof viteReleaseEnvSchema>;
